<div class="alumni-swipper-container relative">
    <swiper-container #swiperEl class="alumni-swipper" init="false">
        <swiper-slide
            tabindex="0"
            class="slide swiper-slide"
            *ngFor="let user of experienceAlumniWidget.content"
            (click)="openUserDetailsDialog(user)"
            (keyup.enter)="openUserDetailsDialog(user)"
        >
            <div class="slide-img-container">
                <div class="slide-img" *ngIf="user.avatar.src; else initials" [style.background-image]="'url(' + user.avatar.src + ')'"></div>
                <ng-template #initials>
                    <div fxLayoutAlign="center center" class="avatar-initials avatar slide-img">{{ user.fullName | initials }}</div>
                </ng-template>
            </div>
            <div class="slide-content" lang="de">
                <h3 class="user-name mb-8">{{ user.fullName }}</h3>
                <ng-container *ngFor="let item of user.attributes">
                    <div class="user-info">
                        <span class="key">{{ item.attribute.translationKey | translate }}:</span>
                        <span class="value" [matTooltip]="(item.attribute | getUserExtendedAttributeValue: user.attributes) || ''" matTooltipPosition="above">
                            {{ (item.attribute | getUserExtendedAttributeValue: user.attributes) || '-' }}</span
                        >
                    </div>
                </ng-container>
            </div>
        </swiper-slide>
    </swiper-container>

    <div class="alumni-swiper-button-next"></div>
    <div class="alumni-swiper-button-prev"></div>
</div>
